/* Anemoia CRT desktop (custom): boots the shared backdrop loops + WebGL CRT
   glass from anemoia-desktop-fx.js. Without JS the plate gradient + CSS glass
   stand in and the folder links still work. */
(() => {
  class AnemoiaDesktop extends HTMLElement {
    connectedCallback() {
      window.AnemoiaDesktopFX?.initBackdrop(this);
      window.AnemoiaDesktopFX?.initCrt(this);
    }
  }

  if (!customElements.get('anemoia-desktop')) customElements.define('anemoia-desktop', AnemoiaDesktop);
})();
